import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory, Link } from 'react-router-dom';

import { ImageLogo } from '~/assets/images';
import { Button } from '~/components';

import { Container, Wrapper, ButtonSignUp, SloganText } from './styles';

const Home = () => {
  const { t } = useTranslation(['Home']);
  const { push } = useHistory();

  return (
    <Container>
      <Wrapper>
        <ImageLogo />

        <Link to="/professional/sign-in" style={{ width: '100%' }}>
          <Button style={{ marginTop: 64 }}>{t('Home:button_signin')}</Button>
        </Link>

        {/* <ButtonSignUp onClick={() => push('/professional/sign-up')}>
          {t('Home:button_signup')}
        </ButtonSignUp> */}

        <SloganText>{t('Home:slogan')}</SloganText>
      </Wrapper>
    </Container>
  );
};

export default Home;
